module.exports = __webpack_public_path__ + "img/9_uk.1b96d73b.svg";